// actions.js
import { GET_USER } from "./actionTypes";

// Called from your component to trigger the saga.
export const getUser = (user) => {
  return {
    type: GET_USER,
    payload: user,
  };
};

